import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '~/store';

export const isIdentifyLoadingSelector = createSelector(
  (state: RootState) => state.antiPirate,
  (antiPirate) => antiPirate.isIdentifyLoading,
);

export const identifyResultSelector = createSelector(
  (state: RootState) => state.antiPirate,
  (antiPirate) => antiPirate.result,
);

export const identifyErrorSelector = createSelector(
  (state: RootState) => state.antiPirate,
  (antiPirate) => antiPirate.errorMessage,
);

export const identifyNotFoundErrorSelector = createSelector(
  (state: RootState) => state.antiPirate,
  (antiPirate) => antiPirate.notFoundError,
);
